import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import { Grid } from '@mui/material';
import { Button, Pill } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import Tabs, { TabContainer } from 'Components/Tabs';
import TableView from 'Components/TableView';
import InputSearch from 'Components/InputSearch';

import './styles.scss';

//actions
import {
    clearRedux,
    accountTagsOpenViewEntitiesModal,
    accountTagsViewEntitiesSearchEntities,
    accountTagsOpenCreateEdit
} from 'Redux/actions';
import { validateTagPermissions } from '../..';

const ViewAccountTagEntities = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const {
        openViewEntities: open,
        filters,
        tag,
        tab,
        entities,
        loadingEntities,
        total,
        onlyView
    } = useSelector(state => state.viewEntitiesTagRedux);
    
    const user = useSelector((state) => state.securityRedux.user);
    const tableViewRef = useRef();
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        return () => {
            dispatch(clearRedux("ACCOUNT_TAGS_VIEW_ENTITIES"));
        }
    }, []);

    const handleClose = useCallback(() => {
        dispatch(accountTagsOpenViewEntitiesModal(false));
        dispatch(clearRedux("ACCOUNT_TAGS_VIEW_ENTITIES"));
    });

    const cutString = useCallback((label, size = 20) => {
        if (label && label.length > size) {
            return `${label.slice(0, size)}...`;
        }

        return messages[label] || label;
    });

    const onSearch = useCallback((text) => {
        if (window.typingTime) {
            clearTimeout(window.typingTime)
        }

        setSearchText(text);
        window.typingTime = setTimeout(() => {
            tableViewRef?.current?.setNewPage(1);
            dispatch(accountTagsViewEntitiesSearchEntities({ ...filters, offset: 0, openSearch: text, reset: true }));
            window.typingTime = null;
        }, 500);
    });
    
    const tabsItems = [
        {
            permission: "",
            permissionSubUser: null,
            iconIndicator: "directions_car",
            label: messages['accountTagsViewEntities_vehicles'],
            entityName: "Unit",
            permissionSubUser: [13]
            
        },
        {
            permission: "",
            permissionSubUser: null,
            iconIndicator: "settings",
            label: messages['accountTagsViewEntities_assets'],
            entityName: "Asset"
        },
        {
            permission: "driver",
            permissionSubUser: [17],
            iconIndicator: "person",
            label: messages['accountTagsViewEntities_drivers'],
            entityName: "Driver"
        },
        {
            permission: "",
            permissionSubUser: null,
            iconIndicator: "flag",
            label: messages['accountTagsViewEntities_landmarks'],
            entityName: "Landmark",
            permissionSubUser: [3]
        },
        {
            permission: "",
            permissionSubUser: null,
            iconIndicator: "pentagon",
            label: messages['accountTagsViewEntities_geofences'],
            entityName: "Geofence",
            permissionSubUser: [1]
        },
        {
            permission: "",
            permissionSubUser: [31],
            iconIndicator: "supervisor_account",
            label: messages['accountTagsViewEntities_users'],
            entityName: "User"
        },
        {
            permission: "dappfrm",
            permissionSubUser: [246],
            iconIndicator: "ballot",
            label: messages['accountTagsViewEntities_dynamicForms'],
            entityName: "DynamicForm"
        },
    ]
    
    const tabsWithPermissions = validateTagPermissions(user, tabsItems)

    const onChangePage = useCallback((page, newTab) => {
        const index = newTab === undefined ? tab : newTab
        const entityName = tabsWithPermissions[index]?.entityName || "";
        dispatch(accountTagsViewEntitiesSearchEntities({
            ...filters,
            offset: (page - 1) * filters.limit,
            parentTagIds: [tag?.id],
            entityName: entityName
        }));
    });

    const renderTable = useCallback(() => {
        return (
            <Grid
                container
                direction="column"
                justifyContent="center"
                spacing={0}
            >
                <Grid item xs={12}>
                    <InputSearch
                        placeholder={messages['search']}
                        searchText={searchText}
                        onSearch={onSearch}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TableView
                        ref={tableViewRef}
                        data={entities || []}
                        loading={loadingEntities}
                        rowsPerPage={filters?.limit || 0}
                        name="entities-tag-list"
                        topSpaceSize={340}
                        //maxHeight={400}
                        //height={400}
                        infiniteScroll={true}
                        viewType="list"
                        messages={messages}
                        itemSelector={false}
                        serverSide
                        onChangePage={onChangePage}
                        total={total}
                        moreRowsAvailable={total > entities?.length}
                        renderRow={(row) => {
                            return (
                                <div style={{ padding: '5px 0px 5px 0px', fontWeight: '700' }}>
                                    {row.label}
                                </div>
                            )
                        }}
                    />
                </Grid>
            </Grid>
        )
    });

    return (
        <Modal
            title={
                <Pill
                    textField="label"
                    item={tag ? { ...tag, label: cutString(tag?.label) } : {}}
                    outlined={false}
                />
            }
            open={(open && tag) ? true : false}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden"
            handleClose={handleClose}
        >
            <ModalBody
                style={{
                    overflow: 'hidden',
                    marginBottom: 0
                }}
            >
                <div style={{ padding: 24, height: "calc(100vh - 225px)" }}>
                    {
                        !onlyView ?
                            <Tabs
                                tab={tab}
                                type="icon-indicator"
                                border
                                onChange={(newTab) => {
                                    if(tab == newTab) return; //no changes same tab
                                    tableViewRef?.current?.setNewPage(1);
                                    setSearchText("");
                                    dispatch(clearRedux("ACCOUNT_TAGS_VIEW_ENTITIES", {
                                        filters: { ...filters, offset: 0, openSearch: "" },
                                        entities: [],
                                        loadingEntities: true,
                                        tab: newTab
                                    }));
                                }}
                            >
                                {tabsWithPermissions.map((tabConfig, index) => {
                                    return (
                                        <TabContainer
                                            key={index}
                                            iconIndicator={tabConfig.iconIndicator}
                                            label={tabConfig.label}
                                            index={tabConfig.index}
                                            style={{ paddingLeft: 0, paddingRight: 0 }}
                                            disabled={loadingEntities}
                                        >
                                            {tab === tabConfig.index && renderTable()}
                                        </TabContainer>
                                    );
                                })}
                            </Tabs> :
                            <div>
                                {renderTable()}
                            </div>
                    }
                </div>
            </ModalBody>


            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loadingEntities}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                {
                    (!onlyView && tag?.id != -1) &&
                    <Button
                        disabled={loadingEntities}
                        onClick={(e) => {
                            handleClose();
                            dispatch(accountTagsOpenCreateEdit(true, tag?.id));
                        }}
                        className="btn-blue"
                    >
                        {messages['edit']}
                    </Button>
                }
            </ModalFooter>


        </Modal>
    );
}

export default ViewAccountTagEntities;